import { withTheme } from 'emotion-theming'
import { useState, useRef } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'
import { useUIDSeed } from 'react-uid'

import Button from 'components/Button'
import PlayIcon from 'public/icons/play.svg'

import style from './BoatVideo.style'

const BoatVideoStyled = styled.div(props => ({ ...style(props) }))

const BoatVideo = ({ t, video, videoSmall, data }) => {
    const [active, setActive] = useState(false)

    const boatVideo = useRef()

    const playVideo = () => {
        if (boatVideo.current) {
            setActive(true)
            if (!videoSmall) {
                boatVideo.current.currentTime = 0
                boatVideo.current.play()
            }
        }
    }

    const uid = useUIDSeed()

    return video ? (
        <BoatVideoStyled active={active}>
            <div className="boatVideoInner">
                <div className="boatVideo">
                    {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                    <video
                        ref={boatVideo}
                        src={active ? video : videoSmall || video}
                        className="boatVideo-video"
                        autoPlay
                        loop={!active}
                        muted={!active}
                        playsInline
                        controls={active}
                    />
                </div>
                <div className="boatVideoOverlay">
                    <div className="boatVideoOverlay-inner">
                        {data && data.length > 0 && (
                            <ul className="boatVideoList">
                                {/* eslint-disable react/no-danger */}
                                {data.map(item => (
                                    <li
                                        className="boatVideoList-item"
                                        key={uid(item)}
                                        dangerouslySetInnerHTML={{ __html: item.text }}
                                    />
                                ))}
                            </ul>
                        )}
                        <Button
                            variation="primary rounded"
                            white
                            small
                            onClick={() => playVideo()}
                            dataAttrs={{
                                'gtm-event': 'video',
                                'gtm-label': 'Video',
                                'gtm-action': 'Play video',
                                'gtm-category': 'Media'
                            }}>
                            {t('play-video')} <PlayIcon />
                        </Button>
                    </div>
                </div>
            </div>
        </BoatVideoStyled>
    ) : null
}

BoatVideo.propTypes = {
    t: PropTypes.func.isRequired,
    video: PropTypes.string,
    videoSmall: PropTypes.string,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired
        })
    )
}

BoatVideo.defaultProps = {
    video: undefined,
    videoSmall: undefined,
    data: []
}

export default withTranslation('common')(withTheme(BoatVideo))
